import { useEffect, useState } from "react";
import { FeatureType } from "../type";
import getAllFeatures from "../function/getAllFeature";
import { toast } from "react-toastify";
import createSubcriptions from "../function/createSubcriptions";

const AddModalSubscriptions = ({ onClose , setTriggerReload }: { onClose: () => void; setTriggerReload: React.Dispatch<React.SetStateAction<number>> }) => {
    const [features, setFeatures] = useState<FeatureType[]>([]);
    useEffect(() => {
        getAllFeatures(0, 0).then((res) => {
            setFeatures(res.filter((feature: FeatureType) => feature.key == null || feature.key == undefined || feature.key == '')); // Only features without key
        }).catch((error) => {
            console.error("Error fetching features:", error);
        });
    }, []);

    const [addSubcriptionName, setAddSubscriptionName] = useState<string>("");
    const [addSubcriptionDescription, setAddSubscriptionDescription] = useState<string>("");
    const [addSubcriptionPrice, setAddSubscriptionPrice] = useState<string>("");
    const [selectedFeatures, setSelectedFeatures] = useState<FeatureType[]>([]);

    function checkData() {
        if (!addSubcriptionName) {
            toast.error("Subscription name is required");
            return false;
        }
        if (!addSubcriptionDescription) {
            toast.error("Subscription description is required");
            return false;
        }
        if (!addSubcriptionPrice || isNaN(Number(addSubcriptionPrice))) {
            toast.error("Valid subscription price is required");
            return false;
        }
        return true;
    }

    async function handleAddSubscription() {
        if (!checkData()) return;
        // Logic to add subscription
        createSubcriptions(
            addSubcriptionName,
            addSubcriptionDescription,
            Number(addSubcriptionPrice),
            selectedFeatures.map(f => f.id)
        ).then((res) => {
            if (res) {
                toast.success("Subscription added successfully");
                setTriggerReload(prev => prev + 1);
            } else {
                toast.error("Failed to add subscription");
            }
        }).catch((error) => {
            console.error("Error adding subscription:", error);
            toast.error("Failed to add subscription");
        });
        // Reset form after adding
        onClose();
    }
    return (
        <div className="px-2 py-4 flex flex-col gap-4">
            <div className="flex flex-col gap-4">
                <div className="flex flex-row gap-4">
                    <div className="flex flex-col gap-2 w-1/2">
                        <div className="flex flex-col gap-2">
                            <label htmlFor="subscriptionName" className="font-medium">Subscription Name</label>
                            <input
                                value={addSubcriptionName}
                                onChange={(e) => setAddSubscriptionName(e.target.value)}
                                type="text" id="subscriptionName" className="border p-2 rounded-lg w-full" placeholder="Enter subscription name" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <label htmlFor="subscriptionDescription" className="font-medium">Subscription Description</label>
                            <textarea
                                value={addSubcriptionDescription}
                                onChange={(e) => setAddSubscriptionDescription(e.target.value)}
                                id="subscriptionDescription" className="min-h-[100px] border p-2 rounded-lg w-full" placeholder="Enter subscription description"></textarea>
                        </div>
                        <div className="flex flex-col gap-2">
                            <label htmlFor="subscriptionPrice" className="font-medium">Subscription Price</label>
                            <input
                                value={addSubcriptionPrice}
                                onChange={(e) => setAddSubscriptionPrice(e.target.value)}
                                type="text" id="subscriptionPrice" className="border p-2 rounded-lg w-full" placeholder="Enter subscription price" />
                        </div>
                    </div>
                    <div className="flex flex-col gap-2 w-1/2 max-h-[300px] overflow-y-auto">
                        <label htmlFor="subscriptionFeatures" className="font-medium">Select Features</label>
                        {features.map((feature) => (
                            <div key={feature.id} className="flex items-center gap-2">
                                <input
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedFeatures([...selectedFeatures, feature]);
                                        } else {
                                            setSelectedFeatures(selectedFeatures.filter(f => f.id !== feature.id));
                                        }
                                    }}
                                    checked={selectedFeatures.some(f => f.id === feature.id)}
                                    type="checkbox" id={`feature-${feature.id}`} className="h-4 w-4" />
                                <label htmlFor={`feature-${feature.id}`} className="text-gray-700">{feature.name} ({feature.number})</label>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="flex justify-end gap-4 mt-4">
                    <button onClick={onClose} className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 transition-colors">
                        Cancel
                    </button>
                    <button
                        onClick={handleAddSubscription}
                        className="px-4 py-2 rounded-lg bg-blue-600 !text-white hover:bg-blue-700 transition-colors">
                        Add Subscription
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddModalSubscriptions;